// social-media-approver.component.js
import moment from 'moment'

// Define the component
class SocialMediaCuratorController {
  constructor ($log, $interval, $timeout, ApiService, $element, $scope, CONFIGURATION) {
    'ngInject'
    this._$log = $log
    this._$interval = $interval
    this._$timeout = $timeout
    this._ApiService = ApiService
    this._$element = $element
    this._$scope = $scope
    this._posts = []
    this._selectedApprovalStatus = 0
    this._maxTextLength = 200
    this.visibleCount = 10
    this.socialMediaConfig = CONFIGURATION.socialMedia || {}
    this.inRotationCount = 0
  }

  $onInit () {
    this.fetchPosts()
    this.attachScrollHandler()
  }

  $onDestroy () {
    if (this._scrollHandler) {
      this._scrollHandler()
    }
  }

  attachScrollHandler () {
    const grid = this._$element[0].querySelector('.flex-grid')
    if (!grid) return
    const handler = () => {
      // Trigger loading more items when 200px from bottom
      if (grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 200) {
        this._$scope.$applyAsync(() => {
          this.visibleCount = Math.min(this.visibleCount + 10, this._posts.length)
        })
      }
    }
    grid.addEventListener('scroll', handler)
    this._scrollHandler = () => grid.removeEventListener('scroll', handler)
  }

  fetchPosts () {
    this._$log.info('Fetching posts for curation')
    this._ApiService.call('socialmediapost/getPostsForCuration', { approvalStatus: this._selectedApprovalStatus })
      .then(posts => {
        this._$log.info(`Fetched ${posts.length} posts for curation`)
        this._posts = posts
        this.visibleCount = 10
        const maxAgeHours = this.socialMediaConfig.postMaxAge || 24
        const cutoff = moment.utc().subtract(maxAgeHours, 'hours')
        this._posts.forEach(post => {
          post.isExpanded = false
          post.truncatedText = this.truncateText(post.caption, this._maxTextLength)
          post.inRotation = moment.utc(post.created).isAfter(cutoff)
        })
        this.inRotationCount = this._posts.filter(p => p.inRotation).length
      })
      .catch(() => {
        this._$log.error('Error fetching posts for curation')
      })
  }

  updatePostApproval (postId, approvalStatus) {
    this._ApiService.call('socialmediapost/updateSocialMediaPost', { id: postId, approvalStatus })
      .then(p => {
        const index = this._posts.findIndex(item => item.id === postId)
        const postlist = this._posts
        this._$log.info('Index', { index, p, postlist })
        if (index !== -1) {
          this._posts.splice(index, 1)
          this.inRotationCount = this._posts.filter(p => p.inRotation).length
        }
      })
      .catch(() => {
        this._$log.error('Error updating post approval state')
      })
  }

  shouldTruncate (text) {
    return text.length > this._maxTextLength + 4
  }

  truncateText (text, maxLength) {
    return this.shouldTruncate(text) ? text.substring(0, maxLength) + '...' : text
  }

  toggleText (post) {
    post.isExpanded = !post.isExpanded
  }
}

export default {
  controller: SocialMediaCuratorController,
  template: require('./social-media-approver.template.html').default
}
